import { Main } from "../../components/utilities";
import ProjectSummaryDetails from "./components/ProjectSummaryDetails";
import { Row} from "react-bootstrap";
import NotesSummaryDetails from "./components/NotesSummaryDetails";
import AccountSummaryDetails from "./components/AccountSummaryDetails";
import PortfolioValuationSummaryDetails from "./components/PortfolioValuationSummaryDetails";
import DashboardLoginsDetails from "./components/DashboardLoginsDetails";

const ClientSummary = () => (
    <Main className="p-3">
        <Row className="g-2">
            <AccountSummaryDetails />
            <PortfolioValuationSummaryDetails />
        </Row>
        <Row className="g-2 mt-1">
            <NotesSummaryDetails />
        </Row>
        <Row className="g-2 mt-1">
            <ProjectSummaryDetails />
            <DashboardLoginsDetails />
        </Row>
    </Main>
);

export default ClientSummary;